var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModalCommunity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_204_3472",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 38.5V1.5H1.5V38.5H38.5Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Navi",
    mask: "url(#mask0_204_3472)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.625 4.6875C10.625 6.62914 9.05102 8.20312 7.10938 8.20312C5.16773 8.20312 3.59375 6.62914 3.59375 4.6875C3.59375 2.74586 5.16773 1.17187 7.10938 1.17187C9.05102 1.17187 10.625 2.74586 10.625 4.6875Z",
    stroke: "#202117",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9688 20H1.25V16.4062C1.25 13.1702 3.87328 10.5469 7.10938 10.5469C10.3454 10.5469 12.9688 13.1702 12.9688 16.4062V20Z",
    stroke: "#202117",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5156 23.5156C23.5156 25.4573 21.9416 27.0312 20 27.0312C18.0584 27.0312 16.4844 25.4573 16.4844 23.5156C16.4844 21.574 18.0584 20 20 20C21.9416 20 23.5156 21.574 23.5156 23.5156Z",
    stroke: "#202117",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8594 38.8281H14.1406V35.2344C14.1406 31.9984 16.7639 29.375 20 29.375C23.236 29.375 25.8594 31.9984 25.8594 35.2344V38.8281Z",
    stroke: "#202117",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4063 4.6875C36.4063 6.62914 34.8323 8.20312 32.8906 8.20312C30.949 8.20312 29.375 6.62914 29.375 4.6875C29.375 2.74586 30.949 1.17187 32.8906 1.17187C34.8323 1.17187 36.4063 2.74586 36.4063 4.6875Z",
    stroke: "#202117",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.75 20H27.0312V16.4062C27.0312 13.1702 29.6545 10.5469 32.8906 10.5469C36.1266 10.5469 38.75 13.1702 38.75 16.4062V20Z",
    stroke: "#202117",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.583 4.14197C13.2483 2.27041 16.4959 1.17181 20 1.17181C23.5043 1.17181 26.7518 2.27041 29.4171 4.14197",
    stroke: "#202117",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2402 20C35.3668 26.1058 31.1316 31.1271 25.4697 33.1287",
    stroke: "#202117",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5302 33.1287C8.86828 31.1271 4.63305 26.1058 3.75977 20",
    stroke: "#202117",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalCommunity);
export default __webpack_public_path__ + "static/media/modal-community.439e6a0a92b27703df5ecca1978d8955.svg";
export { ForwardRef as ReactComponent };